import { Col, Container, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faSpinner } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import GenericCarousel from './GenericCarousel';
import { useTranslation } from 'react-i18next';

const ContentDetails = ({
    title,
    images,
    log,
    children,
    onClickGoBack,
    loadingCarousel,
    customHeader,
}) => {
    const { t } = useTranslation();
    const [showCarousel, setShowCarousel] = useState(true);

    useEffect(() => {
        if (loadingCarousel !== undefined && loadingCarousel === false) {
            setShowCarousel(images?.length > 0);
        }
    }, [loadingCarousel, images]);

    return (
        <Container>
            <Row>
                {onClickGoBack && typeof onClickGoBack === 'function' && log ? (
                    <Col md="12">
                        <a
                            href="#go-back"
                            onClick={e => {
                                e.preventDefault();
                                onClickGoBack();
                            }}
                            className="link"
                        >
                            <FontAwesomeIcon
                                icon={faAngleLeft}
                                className="mr-2"
                            />
                            {t('Voltar')}
                        </a>
                    </Col>
                ) : (
                    ''
                )}

                <Col md="12" className="p-2">
                    <header className="p-2 border-bottom mb-2">
                        {customHeader ? (
                            customHeader
                        ) : (
                            <h2 className="text-black-50 s16 cortxt">
                                {title}
                            </h2>
                        )}
                    </header>
                    <section className="row">
                        {showCarousel ? (
                            <Col md="6">
                                {loadingCarousel ? (
                                    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                                        <FontAwesomeIcon
                                            spin
                                            size="2x"
                                            className="cortxt"
                                            icon={faSpinner}
                                        />
                                    </div>
                                ) : images?.length > 0 ? (
                                    <GenericCarousel images={images} />
                                ) : (
                                    ''
                                )}
                            </Col>
                        ) : (
                            ''
                        )}

                        <Col
                            md={showCarousel ? '6' : '12'}
                            className="flex-column"
                            style={{ gap: '8px', minHeight: '300px' }}
                        >
                            {children}
                        </Col>
                    </section>
                </Col>
            </Row>
        </Container>
    );
};

export default ContentDetails;
